import { createAction, props } from '@ngrx/store';
import { AppInfo, DrawingMapping, FlatterFilesResponse } from '../../../models';
import { ODataResponse } from '../../../models/odata-response.model';

const uploadDocument = createAction('[Admin] upload file', props<{ file: File, metadata: { partNumber: string, container: string } }>());
const uploadDocumentSuccess = createAction('[Admin] upload file success');
const uploadDocumentFail = createAction('[Admin] upload file fail', props<{ error: any }>());

const reportUploadProgress = createAction('[Admin] report upload progress', props<{ progress: number }>());

const removeDrawing = createAction('[Admin] Remove Drawing', props<{ fittingId: number }>());
const removeDrawingSuccess = createAction('[Admin] Remove Drawing Success');
const removeDrawingFail = createAction('[Admin] Remove Drawing Fail', props<{ error: any }>());

const loadAppInfo = createAction('[Admin] Load app info');
const loadAppInfoSuccess = createAction('[Admin] Load app info Success', props<{ info: AppInfo }>());
const loadAppInfoFail = createAction('[Admin] Load app info Fail', props<{ error: any }>());

const loadDrawingMappings = createAction('[Admin] load drawing mappings', props<{ page?: number }>());
const loadDrawingMappingsSuccess = createAction('[Admin] load drawing mappings success', props<{ mappings: ODataResponse<DrawingMapping[]> }>());
const loadDrawingMappingsFail = createAction('[Admin] load drawing mappings fail', props<{ error: any }>());

const checkFlatterFilesExistenceSuccess = createAction('[Admin] checkFlatterFilesExistenceSuccess', props<{ result: { [key: string]: FlatterFilesResponse } }>());
const checkFlatterFilesExistenceFail = createAction('[Admin] checkFlatterFilesExistencefail', props<{ error: any }>());

const changeDrawingMappingsPartNumberFilter = createAction('[Admin] change partnumber filter', props<{ val: string }>());
const changeDrawingMappingsfilenameFilter = createAction('[Admin] change filename filter', props<{ val: string }>());

const addDrawingMapping = createAction('[Admin] add drawing mapping', props<{ dwg: DrawingMapping }>());
const addDrawingMappingSuccess = createAction('[Admin] add drawing mapping success');
const addDrawingMappingFail = createAction('[Admin] add drawing mapping fail', props<{ error: any }>());

const patchDrawingMapping = createAction('[Admin] patch drawing mapping', props<{ partNumber: string, filename: string, dwg: Partial<DrawingMapping> }>());
const patchDrawingMappingSuccess = createAction('[Admin] patch drawing mapping success');
const patchDrawingMappingFail = createAction('[Admin] patch drawing mapping fail', props<{ error: any }>());

const changeActiveTab = createAction('[Admin] change the active tab', props<{ tab: number }>());

export const ROLLUP = {
  uploadDocument,
  uploadDocumentSuccess,
  uploadDocumentFail,
  reportUploadProgress,
  removeDrawing,
  removeDrawingSuccess,
  removeDrawingFail,
  loadAppInfo,
  loadAppInfoSuccess,
  loadAppInfoFail,
  loadDrawingMappings,
  loadDrawingMappingsSuccess,
  loadDrawingMappingsFail,
  checkFlatterFilesExistenceSuccess,
  checkFlatterFilesExistenceFail,
  changeDrawingMappingsPartNumberFilter,
  changeDrawingMappingsfilenameFilter,
  addDrawingMapping,
  addDrawingMappingSuccess,
  addDrawingMappingFail,
  patchDrawingMapping,
  patchDrawingMappingSuccess,
  patchDrawingMappingFail,
  changeActiveTab
}
